import { AiProfileBuilderOnboardFlow, type OnboardFlow } from '~/types/domain';

export function isIncompleteProfileBuilder(candidate: {
    onboard_flow?: OnboardFlow | null;
    profile_complete?: boolean | null;
}): boolean {
    return candidate.onboard_flow === AiProfileBuilderOnboardFlow && !candidate.profile_complete;
}
